import { Component, Input, ViewChild, OnInit } from "@angular/core";
import { Note, NoteService, User } from "../../../core/data";
import { NoteUpdateModalComponent } from "./note-update-modal.component";
import { SessionService } from "../../../core/services";

@Component({
  selector: "app-note-list",
  templateUrl: "./note-list.component.html"
})
export class NoteListComponent implements OnInit {
  @Input() notes: Note[];
  @Input() showVisibility = false;
  @ViewChild(NoteUpdateModalComponent) noteUpdateModal;
  user: User;

  constructor(
    private noteService: NoteService,
    private sessionService: SessionService
  ) {}

  ngOnInit() {
    this.user = this.sessionService.get("profile");
  }

  get canManage() {
    return this.user && this.user.isAdmin || false;
  }

  update(note: Note) {
    this.noteUpdateModal.open(note);
  }

  updated(note: Note) {
    this.noteService.update(note).subscribe(() => window.location.reload());
  }

  remove(note: Note) {
    if (confirm("Are you sure you want to delete this note?")) {
      this.noteService.delete(note).subscribe(() => window.location.reload());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/notes/note-list.component.ts